import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../middlewares/middleware";
import { PLAN_TAGS } from "@features/subscription-plan/constants";
import { BLOG_CATEGORY_TAGS, BLOG_TAGS } from "@features/blog/constants";
import { MACHINERY_REQUEST_TAGS, MACHINERY_TAGS } from "@features/machinery/constants";
import { USER_TAGS } from "@features/users/constants";
import { MACHINERY_CATEGORY_TAGS, MACHINERY_SUB_CATEGORY_TAGS } from "@features/machinery-category/constants";
import { POLICY_TAGS } from "@features/policy/constants";
import { PAYMENT_TAGS } from "@features/payment/constants";
import { FAQ_TAGS } from "@features/faq/constants";
import { NEWS_CATEGORY_TAGS, NEWS_TAG_TAGS, NEWS_TAGS } from "@features/news/constants";
import { BIDDING_TAGS } from "@features/auction/constants";
import { NOTIFICATION_TAGS } from "@features/notification/constants";
import { BRAND_TAGS } from "@features/brand/constants";
import { INVOICE_TAGS } from "@features/invoice/constants";
import { NEWSLETTER_TAGS } from "@features/newsletter/constants";
import { AUTH_TAGS } from "@features/auth/constants";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: [

    ...Object.values(AUTH_TAGS),
    ...Object.values(NEWSLETTER_TAGS),
    ...Object.values(INVOICE_TAGS),
    ...Object.values(BRAND_TAGS),
    ...Object.values(NOTIFICATION_TAGS),
    ...Object.values(BIDDING_TAGS),
    ...Object.values(NEWS_CATEGORY_TAGS),
    ...Object.values(NEWS_TAG_TAGS),
    ...Object.values(NEWS_TAGS),
    ...Object.values(FAQ_TAGS),
    ...Object.values(PAYMENT_TAGS),
    ...Object.values(POLICY_TAGS),
    ...Object.values(MACHINERY_SUB_CATEGORY_TAGS),
    ...Object.values(MACHINERY_CATEGORY_TAGS),
    ...Object.values(USER_TAGS),
    ...Object.values(MACHINERY_REQUEST_TAGS),
    ...Object.values(MACHINERY_TAGS),
    ...Object.values(PLAN_TAGS),
    ...Object.values(BLOG_CATEGORY_TAGS),
    ...Object.values(BLOG_TAGS),

  ],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,

  endpoints: () => ({}),
});
